<template>
	<div class="modal-delete-tag-container delete-clips-container flex-col items-center">
		<h5
			class="modal-delete-tag-title text-white font-uppercase"
		>
			{{ $tc('modals.deleteClipsModal.title') }}
		</h5>
		<h6 class="modal-delete-tag-body delete-clips text-white text-center">
			{{ $tc('modals.deleteClipsModal.mainText') }}
			<div class="delete-clip-name text-truncate">
				{{ options.clipName || $tc('events.view.player-highlightLabel') }}
			</div>
		</h6>
		<div class="modal-delete-tag-buttons flex">
			<button class="button-delete font-regular font-uppercase text-black mr-5 flex-center" @click="onConfirm">
				{{ $tc('actions.delete') }}
			</button>
			<button class="button-light-blue font-regular font-uppercase text-black ml-5 flex-center" @click="onClose">
				{{ $tc('modals.DeleteTagConfirm.cancelButtonText') }}
			</button>
		</div>
	</div>
</template>

<script>
import { ModalMixin } from '~/assets/vue/mixins'

export default {
	name: 'ModalDeleteClipConfirm',
	mixins: [ModalMixin],
	props: {
		options: {
			type: Object,
			required: true
		}
	}
}
</script>

<style lang="scss">

</style>
